import { CSSProperties, useTheme } from 'styled-components';
import { LineSegment } from 'victory';

export interface CustomTickComponentProps {
  index: number;
  ticks: number[];
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  style: CSSProperties;
  datum: number;
  id: string;
}

export interface CustomTickProps {
  isLegacy: boolean;
}

export const CustomXTick: React.FC<CustomTickProps> = ({ isLegacy, ...props }) => {
  const theme = useTheme();

  const tickProps = props as CustomTickComponentProps;
  const isLastLine = tickProps.index === 0;
  const newStyle = {
    stroke: theme.secondary.skyBlue,
    strokeWidth: 1,
    size: 5,
  };

  return <LineSegment {...props} style={isLastLine && !isLegacy ? newStyle : tickProps.style} />;
};
